<template>
    <div class="card category-section-item is-shadowless">
        <div class="card-image">
            <figure class="image">
                <router-link :to="{ name: 'blog.post', params: { slug: post.slug } }">
                    <img :src="post.images.medium" :alt="post.title.rendered">
                </router-link>
            </figure>
        </div>

        <div class="card-content">
            <h4 class="post-title title is-4 has-text-weight-normal">
                <router-link :to="{ name: 'blog.post', params: { slug: post.slug } }">
                    {{post.title.rendered}}
                </router-link>
            </h4>

            <div class="post-text" v-html="post.excerpt.renderedShort"></div>

            <div class="media">
                <div class="media-left">
                    <figure class="image is-48x48 is-rounded">
                        <img class="is-rounded" :src="post.author_data.avatar" alt="Placeholder image">
                    </figure>
                </div>

                <div class="media-content">
                    <p class="title is-6">{{post.author_data.name}}</p>
                    <p class="subtitle is-6 has-text-primary">{{post.author_data.title}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .category-section-item {

        .card-content {
            padding: 1rem 0;
            .post-title {
                margin-bottom: 0.5rem;

                a {
                    color: $black;

                    &:hover {
                        color: $primary;
                    }
                }
            }
        }

        .media {
            padding-top: 1rem;
        }

        .image {
            img {
                max-height: 175px;
                object-fit: cover;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            post: {
                type: Object,
                required: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/blog/components/CategorySectionItem.vue